import { render, staticRenderFns } from "./SurveyQuestionAnswerFcfsOptionEditor.vue?vue&type=template&id=3440c498&scoped=true"
import script from "./SurveyQuestionAnswerFcfsOptionEditor.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionAnswerFcfsOptionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3440c498",
  null
  
)

export default component.exports